import { render, staticRenderFns } from "./new-local-invoice.vue?vue&type=template&id=60a54c34&"
import script from "./new-local-invoice.vue?vue&type=script&lang=js&"
export * from "./new-local-invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports